export default __webpack_public_path__ + "static/media/logo-new.c9afd109.png";